import { Link, makeStyles, Stack } from '@fluentui/react';
import * as React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';

const messages = defineMessages({
    deprecationText: {
        id: 'languageStudio.deprecation.banner.text',
        defaultMessage:
            'Azure Language Studio will be retired and no longer accessible {bold} Please start using Microsoft Foundry to access your projects. {link}'
    },
    disabledDate: {
        id: 'languageStudio.deprecation.banner.disabledDate',
        defaultMessage: 'starting February 16, 2026.'
    },
    link: {
        id: 'languageStudio.deprecation.banner.link',
        defaultMessage: 'Learn more about Foundry migration'
    }
});

const useStyles = makeStyles({
    container: {
        padding: '12px 20px',
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#D13438',
        color: '#FFFFFF',
        fontFamily: 'Segoe UI',
        fontSize: '14px',
        fontWeight: '400',
        display: 'block'
    },
    bold: {
        fontWeight: '600'
    },
    link: {
        color: '#FFFFFF',
        textDecoration: 'underline'
    }
});

// Set to true to re-enable the deprecation banner
const SHOW_DEPRECATION_BANNER = false;

const LanguageStudioDeprecationBanner = () => {
    const styles = useStyles();
    const { localize } = useLocalization();

    if (!SHOW_DEPRECATION_BANNER) {
        return null;
    }

    return (
        <Stack className={styles.container}>
            <FormattedMessage
                {...messages.deprecationText}
                values={{
                    bold: <span className={styles.bold}>{localize(messages.disabledDate)}</span>,
                    link: (
                        <Link
                            href="https://learn.microsoft.com/azure/ai-services/language-service/migration-studio-to-foundry"
                            target="_blank"
                            className={styles.link}>
                            {localize(messages.link)}
                        </Link>
                    )
                }}
            />
        </Stack>
    );
};

export default LanguageStudioDeprecationBanner;
